export default __webpack_public_path__ + "assets/x.609ccec1e6c6c10c412a1ab325258b42.svg";